import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { getAppOriginAndTimezone } from '../../../Utils/getAppOrigin';

const PasswordManagement = {
  name: 'passwordManagement',
  state: {
    loading: false,
    error: '',
    successMessage: '',
    lastSetPassword: null,
  },
  reducers: {
    setTempPasswordRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        successMessage: '',
        lastSetPassword: null,
      };
    },
    setTempPasswordReceived(state, payload) {
      return {
        ...state,
        loading: false,
        successMessage: payload.message,
        lastSetPassword: payload.tempPassword,
        error: '',
      };
    },
    setTempPasswordFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        successMessage: '',
        lastSetPassword: null,
      };
    },
    clearPasswordManagementState(state) {
      return {
        ...state,
        loading: false,
        error: '',
        successMessage: '',
        lastSetPassword: null,
      };
    },
  },
  effects: (dispatch) => ({
    async setTempPassword({ userId, newPassword, notifyUser = true }) {
      try {
        this.setTempPasswordRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const adminUserId = userInfo?.id;
        const orgId = userInfo?.org_id;
        const { origin, timezone } = getAppOriginAndTimezone();

        const response = await http.put(
          `savvy/users/admin/set-temp-password/${userId}`,
          {
            new_password: newPassword,
            org_id: orgId,
            admin_user_id: adminUserId,
            notify_user: notifyUser,
            origin,
            timezone,
          }
        );

        if (response?.data?.success === false) {
          throw new Error(
            response?.data?.message ||
              response?.data?.error ||
              'Failed to set temporary password'
          );
        }

        const message =
          response?.data?.message || 'Temporary password set successfully';

        this.setTempPasswordReceived({
          message,
          tempPassword: newPassword,
        });
      } catch (err) {
        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Failed to set temporary password';

        this.setTempPasswordFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(errorMessage),
            show: true,
          },
        });
      }
    },
    clearState() {
      this.clearPasswordManagementState();
    },
  }),
};

export default PasswordManagement;
